import { getLoginErrorMessage } from "../shared/utils";
import * as commonActionTypes from "../shared/commonActionTypes";
import axios from "axios";
import analytics from "../shared/analytics";

import * as apiEndPoints from "../shared/apiPaths";
import * as actionTypes from "./actionTypes";

export const login = (username, password) => {
  return dispatch => {
    dispatch(loginRequest());

    const url = window.ENV.LOGIN_API_ROOT + apiEndPoints.AUTHENTICATION;

    axios
      .post(url, {
        username: username,
        password: password
      })
      .then(response => {
        dispatch(loginSuccess(response.data));
        var context = window.location.host.split(".", 1)[0].split(":", 1)[0];
        analytics.trackEvent(
          {
            "key": "Login",
            "segmentation": {
              "customer": context
            }
          }
        );
      })
      .catch(error => {
        dispatch(loginFailure(getLoginErrorMessage(error)));
      });
  };
};

const loginRequest = () => {
  return {
    type: actionTypes.LOGIN_REQUEST
  };
};

const loginSuccess = response => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    response: {
      token: response
    }
  };
};

const loginFailure = error => {
  return {
    type: actionTypes.LOGIN_FAILURE,
    error: error
  };
};

export const logout = () => {
  return {
    type: commonActionTypes.LOGOUT
  };
};
